import { usePracticePreferences } from '@witmetrics/data-store';
import {
  FunnelIcon,
  HomeIcon,
  ReportsIcon,
  SegmentsIcon,
  SnapshotsIcon,
} from '@/icons';
import Sidebar, { SidebarButton } from '@/components/Sidebar';
import { classes } from './utils';

export default function AppSidebar() {
  const preferences = usePracticePreferences();

  const sharedProps = {
    color: preferences?.buttonTextColor?.value,
    bgColor: preferences?.buttonBgColor?.value,
  };

  return (
    <Sidebar>
      <SidebarButton
        {...sharedProps}
        href="/dashboard/overview/"
        label="Overview"
        icon={<HomeIcon className={classes.icon} />}
      />
      <SidebarButton
        {...sharedProps}
        href="/dashboard/snapshots/"
        label="Snapshots"
        icon={<SnapshotsIcon className={classes.icon} />}
      />
      <SidebarButton
        {...sharedProps}
        href="/dashboard/funnel/"
        label="Funnel"
        icon={<FunnelIcon className={classes.icon} />}
      />
      <SidebarButton
        {...sharedProps}
        href="/dashboard/segments/"
        label="Segments"
        icon={<SegmentsIcon className={classes.icon} />}
      />
      <SidebarButton
        {...sharedProps}
        href="/dashboard/reports/"
        label="Reports"
        icon={<ReportsIcon className={classes.icon} />}
      />
    </Sidebar>
  );
}
